import React, { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import { format } from "date-fns";
import { config, encodeBase64RequestBody, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const ContactDetail = () => {
  const { id_contact } = useParams();
  const [contact, setContact] = useState(null);
  const [opportunities, setOpportunities] = useState(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const navigate = useNavigate();

  useEffect(() => {
    getContact();
  }, []);

  useEffect(() => {
    if (contact) {
      getOpportunities();
    }
  }, [contact]);

  const getContact = async () => {
    try {
      const requestGetContact = {
        "id_contact_person": id_contact
      }
      const fetchGetContact = await jwtFetch(config.ENDPOINT + 'get/contact_person', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encodeBase64RequestBody(requestGetContact)
      });
      const responseGetContact = await fetchGetContact.json();
      if (responseGetContact.status === 200) {
        setContact(responseGetContact.data[0]);
      } else {
        alert(responseGetContact.message);
      }
    } catch (error) {
      console.error('Error in getContact:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getOpportunities = async () => {
    try {
      const requestGetOpportunity = {
        "contact_person_id": id_contact
      }
      const fetchGetOpportunity = await jwtFetch(config.ENDPOINT + 'get/opportunity', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetOpportunity)
      });
      const responseGetOpportunity = await fetchGetOpportunity.json();
      if (responseGetOpportunity.status === 200) {
        setOpportunities(responseGetOpportunity.data);
      } else {
        alert(responseGetOpportunity.message);
      }
    } catch (error) {
      console.error('Error in getOpportunities:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  return (
    <div id="contact-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="client" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Contact Detail</div>
                    {(crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View') && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/client/contact/edit/' + id_contact}><i className="bi bi-pencil me-1" /> Edit</button>
                    )}
                  </div>
                  {contact ? (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Company Group</div>
                          <div className="col-md-8">{contact.company_name} <a href={"/client/detail/" + contact.company_id}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Subsidiary</div>
                          <div className="col-md-8">{contact.subcompany_name} <a href={"/client/subsidiary/detail/" + contact.subcompany_id}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Name</div>
                          <div className="col-md-8">{contact.cperson_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Email</div>
                          <div className="col-md-8">{contact.cperson_email}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Phone</div>
                          <div className="col-md-8">{contact.cperson_phone}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Position</div>
                          <div className="col-md-8">{contact.cperson_position}</div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

                <section className="mb-4">
                  <Tabs className="mb-3" defaultActiveKey="opportunities">
                    <Tab eventKey="opportunities" title="Opportunities">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="fs-24">Opportunity List</div>
                        {(crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View') && (
                          <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.open('/opportunity/add/' + contact.company_id, '_blank')}><i className="bi bi-plus-lg me-1" /> Add</button>
                        )}
                      </div>
                      {opportunities && opportunities.length ? (
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="bg-primary text-light">#</th>
                                <th className="bg-primary text-light">Number</th>
                                <th className="bg-primary text-light text-center">Status</th>
                                <th className="bg-primary text-light">Created Date</th>
                                <th className="bg-primary text-light">SKUs</th>
                                <th className="bg-primary text-light text-end">Amount</th>
                                {crmUser.user_department !== 'Sales Admin' && (
                                  <th className="bg-primary"></th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {opportunities.map((opportunity, q) =>
                                <tr key={"opportunity-" + [q]} onClick={() => window.location.href = '/opportunity/detail/' + opportunity.id_opportunity}>
                                  <td valign="middle">{q + 1}</td>
                                  <td valign="middle">{opportunity.opportunity_code}</td>
                                  <td valign="middle" align="center"><span className={"badge bg-" + (opportunity.opportunity_status === 'Won' ? 'success' : 'secondary')}>{opportunity.opportunity_status}</span></td>
                                  <td valign="middle">{format(opportunity.created_on, 'd MMM yyyy')}</td>
                                  <td valign="middle" title={opportunity.item_list_names}>{opportunity.item_list}</td>
                                  <td valign="middle" align="right">{priceFormat(opportunity.opportunity_total, opportunity.opportunity_currency)}</td>
                                  {crmUser.user_department !== 'Sales Admin' && (
                                    <td valign="middle" align="right"><a className="btn btn-icon btn-outline-secondary"><i className="bi bi-eye" /></a></td>
                                  )}
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No data</p>
                      )}
                    </Tab>
                  </Tabs>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetail;


